// extracted by mini-css-extract-plugin
var _1 = "_branchBaseForm-module__button-container";
var _2 = "_branchBaseForm-module__button-subcontainer";
var _3 = "_branchBaseForm-module__container";
var _4 = "_branchBaseForm-module__form-container";
var _5 = "_branchBaseForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "span-2" }
